import ConfirmButtons from '@zeus/core/buttons/ConfirmButtons';
import RequiredField from '@zeus/core/RequiredField';
import MarkdownEditor, { HIDE_SIDE_BY_SIDE_OPTIONS } from '_/common/components/MarkdownEditor';
import { Card, Typography } from 'antd';
import Markdown from 'markdown-to-jsx';
import React, { ReactElement, useEffect, useState } from 'react';

interface ClickToEditMultiProps {
  disabled?: boolean;
  onSaveClick: (text: string) => void;
  text?: string;
  title?: string;
}

function ClickToEditMulti({ disabled, onSaveClick, text, title }: ClickToEditMultiProps): ReactElement {
  const [isEditMode, setEditMode] = useState(false);
  const [isSaveDisabled, setSaveDisabled] = useState(true);
  const [textValue, setTextValue] = useState('');

  useEffect(() => {
    if (text || text === '') {
      setTextValue(text);
    }
  }, [text]);

  const onActionAreaClick = () => {
    const edit = !isEditMode;

    setEditMode(edit);
  };

  const handleTextChange = (value?: string) => {
    if (value?.length && value !== text) {
      setTextValue(value);
      setSaveDisabled(false);
    } else {
      setTextValue(value || '');
      setSaveDisabled(true);
    }
  };

  const handleCancel = () => {
    setTextValue(text || '');
    setEditMode(false);
  };

  const handleSave = () => {
    onSaveClick(textValue);
    setEditMode(false);
  };

  return (
    <div style={{ width: '100%' }}>
      {isEditMode && !disabled ? (
        <Card
          variant="borderless"
          styles={{ body: { padding: 10 } }}
          actions={[
            <div key="actions" style={{ display: 'flex', justifyContent: 'start', padding: '0 16px', gap: '15px' }}>
              <ConfirmButtons
                confirmText="Save"
                disabled={isSaveDisabled}
                noWrapper
                onCancel={handleCancel}
                onConfirm={handleSave}
                size={'middle'}
              />
            </div>,
          ]}
        >
          <Typography.Text strong>{title || ''}</Typography.Text>
          <MarkdownEditor editorOptions={HIDE_SIDE_BY_SIDE_OPTIONS} onChange={handleTextChange} value={textValue} />
          {!textValue?.length && <RequiredField />}
        </Card>
      ) : (
        <div style={{ minWidth: 400, marginTop: 0 }}>
          <Card styles={{ body: { padding: '15px', cursor: 'text' } }} hoverable onClick={onActionAreaClick}>
            <Typography.Text strong>{title || ''}</Typography.Text>
            <Markdown data-test-id="click-to-edit-markdown">{textValue || '## Click to Add a Readme'}</Markdown>
          </Card>
        </div>
      )}
    </div>
  );
}

export default ClickToEditMulti;
